import { OperationStatus } from "../gateway/OperationStatus/OperationStatus";

export class RemoveManyOperationStatusUsecase {
    constructor() {
        this.OperationStatusGateway = new OperationStatus();
    }

    async execute({ companyId = "", status = [] } = {}) {
        const payload = this.sanitizeInput({ companyId, status });
        if (!payload.companyId || !payload.status.length) return false;
        const response = await this.OperationStatusGateway.removeMany(payload);
        return response;
    }

    sanitizeInput({ companyId = "", status = [] } = {}) {
        const sanitizedCompanyId = String(companyId).trim();
        const sanitizedStatus = Array.isArray(status)
            ? status
                  .map((value) => String(value).trim())
                  .filter(Boolean)
            : [];
        return {
            companyId: sanitizedCompanyId,
            status: sanitizedStatus
        };
    }
}
